const ExpenseDayEvents = ({dayData}) => {
    const substract = dayData?.deals?.length >= 3 ? 3 : dayData?.deals?.length;

    return (
        <div className='flex-1 h-full flex flex-col justify-between gap-0.5'>
            <div>
                {
                    dayData?.deals.map((event, index) => {
                        if (index < 3) {
                            return (
                                <div className="flex flex-row items-center mb-1" key={event.id}>
                                    <div className='w-1.5 h-1.5 mr-1.5 rounded-full bg-slate-500'/>
                                    <p className="text-xs w-full overflow-x-hidden whitespace-nowrap">
                                        {event.short_name}
                                    </p>
                                </div>
                            );
                        }
                    })
                }
            </div>
            
            <div className="flex items-center justify-between w-full h-5">
                {
                    (dayData?.amount) &&
                        <p className="text-left text-gradient w-fit">
                            {dayData?.amount} €
                        </p>
                }
                
                {
                    dayData?.count > 3 &&
                        <p className="flex items-center justify-center h-5 min-w-[20px] w-fit text-[9px] py-[1px] px-1 font-bold leading-none text-left text-white rounded-full roboto bg-[#212121]">
                            +{dayData?.count - substract}
                        </p>
                }
            </div>
            {/* {
                expenses.length > 2 &&
                <div className="h-5">
                    <p className="flex items-center justify-center h-5 min-w-[20px] w-fit text-[9px] py-[1px] px-1 font-bold leading-none text-left text-white rounded-full roboto bg-[#212121]">
                        +{expenses.length - 2}
                    </p>
                </div>
            } */}
        </div>

    );
};

export default ExpenseDayEvents;
